import { useEffect } from "react";
import { useSetHeaderContent } from "./useAppStore";

export function useHeader(
    title,
    subTitle = "",
    canGoBack = true,
    canCopyTitle = false,
    canCopySubTitle = false) {

    const updateHeaderContent = useSetHeaderContent();

    useEffect(() => {
        updateHeaderContent(
            title,
            subTitle,
            canGoBack,
            canCopyTitle,
            canCopySubTitle);
    }, []);
}

